{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Spalvų parinkiklis",
  "twoDimensionalSlider": "2D slankiklis"
}
